import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../../css/home.css';
import ApiService from '../../../../services/api'
import img1 from '../../../../media/1.png';
import img2 from '../../../../media/2.jpg';
import img3 from '../../../../media/3.jpg';
import img4 from '../../../../media/4.jpg';
import img5 from '../../../../media/5.jpg';
import target from '../../../../media/target.png';
import tsuccess from '../../../../media/target_success.png';
import start from '../../../../media/start_now.jpg';
import csa from '../../../../media/clever.png';
import certificate from '../../../../media/certificate.png';
import infinite from '../../../../media/24h.png';
import experience from '../../../../media/work_history.png';
import usability from '../../../../media/all_inclusive.png';
import  availability from '../../../../media/ads_click.png';
import convenience from '../../../../media/euro.png';
import Timer from '../../../../media/timer_3.png';
import Fake1 from '../../../../media/fake1.jpg';
import Fake2 from '../../../../media/fake2.jpg';
import Fake3 from '../../../../media/fake3.jpg';
import Fake4 from '../../../../media/fake4.png';
import Fake6 from '../../../../media/fake6.png';
import Fake7 from '../../../../media/fake7.jpg';
import Fake8 from '../../../../media/fake8.jpg';
import Fake9 from '../../../../media/fake9.png';
import Acn from '../../../../media/acn.png';
import Star from '../../../../media/star.png';
import Ai from '../../../../media/ai.png';
import Iso1 from '../../../../media/iso1.png';
import Iso2 from '../../../../media/iso2.png';
import Iso3 from '../../../../media/iso3.png';
import Iso4 from '../../../../media/iso4.png';
import Iso5 from '../../../../media/iso5.png';
import Iso6 from '../../../../media/iso6.png';
import Iso7 from '../../../../media/iso7.png';
import Connections from '../../../../media/connections.png';
import Logo from '../../../../media/logo.png';
import iso27001_2022 from '../../../../media/Certificazione-27001-2022-Actainfo.jpg';
import iso27017_2015 from '../../../../media/20260421-27017-2015-Actainfo.jpg';
import iso27018_2025 from '../../../../media/20260421-27018-2025-Actainfo.jpg';
import iso27701_2019 from '../../../../media/Certificazione-27701-2019-Actainfo.jpg';
import iso9001_2015 from '../../../../media/Certificazione_ISO_9001-2015_Actainfo.jpg';
import { AuthContext } from '../../../../services/authContext';



const slides = [
  {
    image: img1,
    title: "Actafad eLearning",
    description: "Portale di formazione online che integra contenuti di qualità e un’esperienza di apprendimento semplice ed efficiente.",
  },
  {
    image: img2,
    title: "Esperienza",
    description: "Rilasciati oltre 1.300 attestati on line dal 2019.",
  },
  {
    image: img3,
    title: "Fruibilità",
    description: "Consente di apprendere in ogni momento.",
  },
  {
    image: img4,
    title: "Convenienza",
    description: "Più economica in termini di tempo e denaro.",
  },
  {
    image: img5,
    title: "Disponibilità",
    description: "Disponibile ovunque ci sia una connessione Internet.",
  }
];


const previewAutoplayDelay = 5000;

const getPreviewPosition = (index, selectedIndex, total) => {
  let offset = (index - selectedIndex + total) % total;

  if (offset > Math.floor(total / 2)) {
    offset -= total;
  }

  if (offset === 0) return "selected";
  if (offset === -1) return "prev";
  if (offset === -2) return "prevLeftSecond";
  if (offset === 1) return "next";
  if (offset === 2) return "nextRightSecond";

  return offset < 0 ? "hideLeft" : "hideRight";
};

const CoursePreviewCarousel = ({ courses }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isAutoplayPaused, setIsAutoplayPaused] = useState(false);
  const touchStartX = useRef(null);

  const moveCarousel = (direction) => {
    if (!courses.length) return;

    setSelectedIndex((previousIndex) => (
      (previousIndex + direction + courses.length) % courses.length
    ));
  };

  useEffect(() => {
    if (isAutoplayPaused || !courses.length) return undefined;

    const autoplayTimeout = window.setTimeout(() => {
      setSelectedIndex((previousIndex) => (
        (previousIndex + 1) % courses.length
      ));
    }, previewAutoplayDelay);

    return () => window.clearTimeout(autoplayTimeout);

  }, [selectedIndex, isAutoplayPaused, courses.length]);


  useEffect(() => {
    if (selectedIndex >= courses.length) {
      setSelectedIndex(0);
    }
  }, [courses.length, selectedIndex]);

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      moveCarousel(-1);
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      moveCarousel(1);
    }
  };

  const handleTouchStart = (event) => {
    setIsAutoplayPaused(true);
    touchStartX.current = event.changedTouches[0].clientX;
  };

  const handleTouchEnd = (event) => {
    if (touchStartX.current === null) return;

    const distance = event.changedTouches[0].clientX - touchStartX.current;
    touchStartX.current = null;

    if (Math.abs(distance) >= 45) {
      moveCarousel(distance > 0 ? -1 : 1);
    }

    setIsAutoplayPaused(false);
  };

  const handleFocusCapture = () => {
    setIsAutoplayPaused(true);
  };

  const handleBlurCapture = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setIsAutoplayPaused(false);
    }
  };

  if (!courses.length) return null;


  return (
    <div
      className="preview-carousel"
      role="region"
      aria-roledescription="carosello"
      aria-label="Anteprima dei corsi"
      tabIndex="0"
      onKeyDown={handleKeyDown}
      onMouseEnter={() => setIsAutoplayPaused(true)}
      onMouseLeave={() => setIsAutoplayPaused(false)}
      onFocusCapture={handleFocusCapture}
      onBlurCapture={handleBlurCapture}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <div className="preview-carousel-track">
        {courses.map((course, index) => {
          const position = getPreviewPosition(index, selectedIndex, courses.length);
          const isSelected = index === selectedIndex;

          return (
            <Link
              key={course.id}
              to={`/course/${course.slug}`}
              className={`preview-carousel-item ${position} ${course.featured ? 'is-featured' : ''}`}
              onClick={(event) => {
                if (!isSelected) {
                  event.preventDefault();
                  setSelectedIndex(index);
                }
              }}
              aria-current={isSelected ? 'true' : undefined}
              aria-label={
                isSelected
                  ? `${course.title}. Apri il catalogo dei corsi`
                  : `Mostra ${course.title}`
              }
              tabIndex={isSelected ? 0 : -1}
            >
              <article className="preview-carousel-card">
                <div className="preview-carousel-image-wrapper">
                  <img
                    className="preview-carousel-image"
                    src={course.main_img}
                    alt=""
                  />
                </div>

                <div className="preview-carousel-card-body">
                  <h3 className="preview-carousel-card-title">
                    {course.title}
                  </h3>
                  <span
                    className={`preview-carousel-card-hint ${isSelected ? 'is-visible' : ''}`}
                    aria-hidden={!isSelected}
                  >
                    Clicca per aprire
                  </span>
                </div>
              </article>
            </Link>
          );
        })}
      </div>

      <div className="preview-carousel-controls">
        <button
          type="button"
          className="preview-carousel-button"
          onClick={() => moveCarousel(-1)}
          aria-label="Corso precedente"
        >
          ‹
        </button>

        <span className="preview-carousel-counter" aria-live="polite">
          {selectedIndex + 1} / {courses.length}
        </span>

        <button
          type="button"
          className="preview-carousel-button"
          onClick={() => moveCarousel(1)}
          aria-label="Corso successivo"
        >
          ›
        </button>
      </div>
    </div>
  );
};


const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [highlightedCourses, setHighlightedCourses] = useState([]);
  const [courses, setCourses] = useState([]);
  const { isAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const data = await ApiService.getCourses();

        setCourses(data);

        const highlighted = data.filter(course => course.highlighted);
        setHighlightedCourses(highlighted);

      } catch (error) {
        console.error(error);
      }
    };

    fetchCourses();
  }, []);


  const renderStars = (rating, clickable = false) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      let starClass = "empty";
      if (i <= rating) {
        starClass = "filled";
      } else if (i - rating <= 0.5) {
        starClass = "half";
      }
      stars.push(
        <span
          key={i}
          className={`star ${starClass} ${clickable ? "clickable" : "disabled"}`}
        >
          ★
        </span>
      );
    }
    return stars;
  };

  return (
    <div className="homepage-container-wrapper">
      
      
      <div className="hero">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`hero-background ${currentSlide === index ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          />
          ))}
          <div className="hero-overlay" />

        {slides.map((slide, index) => (
          <div
            key={index}
            className={`hero-content ${currentSlide === index ? 'active' : ''}`}
          >
            <h1 className="hero-title">{slide.title}</h1>
            <p className="hero-description">{slide.description}</p>
            <Link to= "/create-account">
            {!isAuthenticated && (
              <button className="register-button">
                Registrati ora
              </button>
            )}
            </Link>
          </div>
        ))}
      </div>

      <div>
        <h2 className='target-title' style={{textAlign:'center' , marginBottom: '40px'}}>Piattaforma certificata</h2>
        <div className="image-grid">
          <a href="https://www.acn.gov.it/portale/w/sa-8334" target="_blank" rel="noopener noreferrer">
            <img src={Acn} alt="" />
          </a>
          <a href="https://cloudsecurityalliance.org/star/registry/actainfo-di-addari-igino-s-a-s/services/e-learning-actainfo/" target="_blank" rel="noopener noreferrer">
            <img src={Star} alt="" />
          </a>
          <a href="https://digital-strategy.ec.europa.eu/en/news/strong-backing-code-practice-transparency-ai-generated-content" target="_blank" rel="noopener noreferrer">
            <img src={Ai} alt="" />
          </a>
          <a href="https://www.actainfo.it/wp-content/uploads/2026/06/Certificazione_ISO_9001-2015_Actainfo.jpg" target="_blank" rel="noopener noreferrer">
            <img src={Iso1} alt="" />
          </a>
          <a href="https://www.actainfo.it/wp-content/uploads/2026/08/Certificazione-ACTAINFO-S.R.L.14001.jpg" target="_blank" rel="noopener noreferrer">
            <img src={Iso2}alt="" />
          </a>
          <a href="https://www.actainfo.it/wp-content/uploads/2026/04/Certificazione-27001-2022-Actainfo.jpg" target="_blank" rel="noopener noreferrer">
            <img src={Iso3} alt="" />
          </a>
          <a href="https://www.actainfo.it/wp-content/uploads/2026/04/20260421-27017-2015-Actainfo.jpg" target="_blank" rel="noopener noreferrer">
            <img src={Iso4} alt="" />
          </a>
          <a href="https://www.actainfo.it/wp-content/uploads/2026/04/20260421-27018-2025-Actainfo.jpg" target="_blank" rel="noopener noreferrer">
            <img src={Iso5} alt="" />
          </a>
          <a href="https://www.actainfo.it/wp-content/uploads/2026/04/Certificazione-27701-2019-Actainfo.jpg" target="_blank" rel="noopener noreferrer">
            <img src={Iso6} alt="" />
          </a>
          <a href="https://www.actainfo.it/wp-content/uploads/2026/08/Certificazione-ACTAINFO-S.R.L.42001.jpg" target="_blank" rel="noopener noreferrer">
            <img src={Iso7} alt="" />
          </a>
        </div>
      </div>



      <div className="all-courses-preview-section">
        <h2 className='target-title'>Inizia il tuo percorso formativo</h2>
        <p className='target-description'>Corsi sempre aggiornati realizzati da esperti del settore professionisti, per offrirti informazioni affidabili, approfondite e sempre al passo con le ultime tecnologie.</p>

        {courses.length > 0 && (
          <CoursePreviewCarousel courses={courses} />
        )}
      </div>




      <div className="highlighted-courses-section">
        <h2 className="highlighted-title">Corsi in evidenza</h2>
        <div className="highlighted-courses-grid2">
          {highlightedCourses.map(course => {
            const avgRating = course.avg_rating ? course.avg_rating / 2 : 0; 
            const totalReviews = course.total_reviews || 0;

            return(
              <Link style={{ textDecoration: 'none' }} to={`/course/${course.slug}`}>
              <div key={course.id} className="highlighted-course-card">
                <div className="course-image-wrapper">
                  <img src={course.main_img} alt={course.title} className="highlighted-course-image" />
                </div>

                <div className="highlighted-course-info">
                  <h3 className="highlighted-course-title">{course.title}</h3>
                  <p className="highlighted-course-description">
                    <img style={{width:"24px", height:"24px", marginTop:"-5px" ,marginRight: "10px"}} src={Timer} alt="" />
                    {course.my_total_duration
                    ? `${course.my_total_duration} ${
                        course.my_total_duration === 1 ? "ora" : "ore"
                      }`
                    : course.total_duration
                      ? course.total_duration < 60
                        ? `${course.total_duration} min`
                        : `${Math.floor(course.total_duration / 60)} ${
                            Math.floor(course.total_duration / 60) === 1 ? "ora" : "ore"
                          }`
                      : "0 min"}
                  </p>

                  <div className="highlighted-course-footer">
                    <div className="highlighted-rating">
                      {renderStars(avgRating)}
                      <span className="reviews">({totalReviews})</span>
                    </div>
                    <Link style={{ textDecoration: 'none' }} to={`/course/${course.slug}`}>
                    <button className="highlighted-button">Dettagli</button>
                    </Link>
                  </div>
                </div>
              </div>
              </Link>
          );
          })}
        </div>
      </div>

      
      <div className="why-section">
        <h2 className="why-title">Perché scegliere la nostra piattaforma</h2>
        <div className="why-grid">
          <div className="why-item">
            <i className="fa-solid fa-laptop-code"></i>
            <h3>Accesso 24/7</h3>
            <p>Studia quando vuoi, da qualsiasi dispositivo.</p>
            <img src={infinite} alt="" className="why-image" />
          </div>
          <div className="why-item">
            <i className="fa-solid fa-user-graduate"></i>
            <h3>Attestato formativo</h3>
            <p>Al termine del corso ricevi un attestato che riconosce il completamento del percorso formativo.</p>
             <img src={certificate} alt="" className="why-image" />
          </div>
          <div className="why-item">
            <i className="fa-solid fa-people-group"></i>
            <h3>Corsi sempre aggiornati</h3>
            <p>In linea con  le evoluzioni tecnologiche e normative.</p>
             <img src={csa} alt="" className="why-image" />
          </div>
        </div>
      </div>

      <section className="cta-section">
        <div className="cta-banner">
          <div className="cta-image">
              <img src={Connections} alt="" />
            </div>
          <div className="cta-content">
            <h2><img src={Logo} style={{marginTop:'-5px', marginRight: '10px'}} alt="" />Software di Actainfo</h2>
            <p>Applicativi CLOUD SAAS realizzati da Actainfo, qualificati da ACN, certificati UNI ISO 9001, 27001, 27701, 27017 
              e 27018 con accesso SPID e CIE, con pagamento PagoPA dei servizi digitali, a norma del PNRR e delle Linee guida di 
              AGID. <br />Il Catalogo degli applicativi comprende la gestione della privacy, della cybersicurezza, di Intelligenza 
              Artificiale – AI, la creazione e gestione di siti web istituzionali, tematici ed e-commerce, la gestione degli 
              obblighi di trasparenza e anti corruzione, la segnalazione degli illeciti whistleblowing, la transizione digitale, 
              la conservazione digitale, la gestione FOIA, la domanda  e l’offerta di lavoro, la gestione e condivisione di pratiche  
              con servizi personalizzati su misura per imprese e pubblica amministrazione. Servizio di on boarding API su piattaforma PDND.</p>
            <a href="https://www.actainfo.it/" target='blank'>
            <button className="cta-button">Scopri di più</button>
            </a>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;